interface SEOHeadProps {
  title?: string;
  description?: string;
  keywords?: string;
  canonicalUrl?: string;
  ogType?: string;
}

export default function SEOHead({ title, description, keywords, canonicalUrl, ogType = 'website' }: SEOHeadProps) {
  useEffect(() => {
    const defaultTitle = '最新网址导航 - 实时更新官方入口 | 最新网址大全';
    const defaultDesc = '最新网址导航汇集各大平台官方最新网址入口，实时更新百度、Google、微信、微博、淘宝、京东等平台最新网址。告别失效链接，一键直达目标网站。';
    const defaultKeywords = '最新网址,最新网址导航,最新网址入口,官方最新网址,最新网址大全,可用网址查询,网址实时更新';

    const finalTitle = title ? `${title} - 最新网址导航` : defaultTitle;

    document.title = finalTitle;

    const setMeta = (name: string, content: string, attrName = 'name') => {
      let el = document.querySelector(`meta[${attrName}="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attrName, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', description || defaultDesc);
    setMeta('keywords', keywords || defaultKeywords);
    setMeta('og:title', finalTitle, 'property');
    setMeta('og:description', description || defaultDesc, 'property');
    setMeta('og:type', ogType, 'property');
    if (canonicalUrl) {
      setMeta('og:url', canonicalUrl, 'property');
      let link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
      if (!link) {
        link = document.createElement('link');
        link.rel = 'canonical';
        document.head.appendChild(link);
      }
      link.href = canonicalUrl;
    }
    setMeta('twitter:title', finalTitle);
    setMeta('twitter:description', description || defaultDesc);
  }, [title, description, keywords, canonicalUrl, ogType]);

  return null;
}